import { render } from "./claim-create.vue?vue&type=template&id=120d5958"
import script from "./claim-create.vue?vue&type=script&lang=js"
export * from "./claim-create.vue?vue&type=script&lang=js"

import "./claim-create.vue?vue&type=style&index=0&id=120d5958&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__